export function not(pred, thisArg) {
    return function (value, index) { return !pred.call(thisArg, value, index); };
}
